import { DuplicateId, DuplicateIdProps } from "@mcleod/dispatch";
import { AutogenLayoutMobileCommGroup } from "./autogen/AutogenLayoutMobileCommGroup";

const viewMCGroupCodeURL = "lme/dispatch/mobilecomm/MobileCommGroup?mode=update&key=";
const DUPLICATE_VALIDATION_PROPS: DuplicateIdProps = {
    tableName: "mc_group",
    screenName: "Mobile Comm Group",
    navigateToUrl: viewMCGroupCodeURL
};
export class MobileCommGroup extends AutogenLayoutMobileCommGroup {
    override onLoad(): void {
        DuplicateId.configureIdTextbox(this.textboxName, DUPLICATE_VALIDATION_PROPS);
    }

    textboxVendorBeforeLookupModelSearch(event) {
        event.filter.is_active = 'Y';
    }
}
